import Vue from 'vue'
import toastr from '../toastr'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import SimpleSingleselect from '../../component/singleselect.vue'
import UploadFile from '../../component/dccore-form/uploadFile.vue'

if ($('#offer_import_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#offer_import_form',
    components: {
      RingLoader,
      UploadFile,
      Singleselect,
      SimpleSingleselect
    },
    mixins: [mixins],
    data: {
      loading: 0,
      file: null,
      supplier: null,
      suppliers: [],
      products: [],
      productsWithCreate: [{ 'id' : 0,
        'name' : 'Stwórz nowy' }],
      errors: {},
      importData: null,
      deletedOffers : [],
    },
    mounted: function () {
      this.getSuppliers()
      this.getProducts()
    },
    methods: {
      importCSV() {
        this.loading++
        $('#button-save-and-back').button('loading')
        let url = Routing.generate('api_import_offer')
        let data = {
          file : this.file,
          supplierId : this.supplier
        }
        this.$http.post(url, data).then(response => {
          this.importData = response.data
          this.deletedOffers = []
          toastr.success(Translator.trans('offer.import.imported'))
          $('#button-save-and-back').button('reset')
          this.loading--
        }, response => {
          $('#button-save-and-back').button('reset')
          this.loading--
          this.handleAjaxError(response)
        })
      },
      saveOffers() {
        $('.button-save').button('loading')
        this.loading++
        let url = Routing.generate('api_post_offer_save_offers', { id: this.supplier })
        let deletedOffers = this.deletedOffers
        // removed deleted offers from importData
        let data = {
          data : this.importData.filter((value, index) => {
            return deletedOffers.indexOf(index) < 0
          }, deletedOffers),
        }

        this.$http.post(url, data).then(() => {
          toastr.success(Translator.trans('offer.import.saved'))
          this.importData = null
          this.$forceUpdate()
          this.loading--
          $('.button-save').button('reset')
        }, response => {
          this.loading--
          $('.button-save').button('reset')
          this.handleAjaxError(response)
        })
      },
      getSuppliers() {
        this.loading++
        let url = Routing.generate('api_get_suppliers', { context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.suppliers = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getProducts() {
        this.loading++
        let url = Routing.generate('api_get_active_products', { context: 'import' })
        this.$http.get(url).then(response => {
          this.productsKg = response.data.filter((product) => {
            return product.unit === 'kg'
          })

          this.productsPiece = response.data.filter((product) => {
            return product.unit === 'piece'
          })

          this.productsKgWithCreate = this.productsWithCreate.concat(this.productsKg)
          this.productsPieceWithCreate = this.productsWithCreate.concat(this.productsPiece)
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getProductsByInfo(unit, creatable) {
        if (unit === 'kg') {
          return creatable ? this.productsKgWithCreate : this.productsKg
        } else {
          return creatable ? this.productsPieceWithCreate : this.productsPiece
        }
      },
      deleteRow(index) {
        this.deletedOffers.push(index)
      },
    }
  })
}
